import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import { useRecordContext } from "react-admin";
import { Student } from "../providers/studentsProvider";

export function HubspotIdMenuItem(props: { closeMenu: () => void; openDialog: () => void }) {
  const { closeMenu, openDialog } = props;
  const student = useRecordContext<Student>();

  if (!student) {
    return null;
  }

  const handleClick = () => {
    closeMenu();
    openDialog();
  };

  return (
    <MenuItem onClick={handleClick}>
      <ListItemIcon>
        <BusinessIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>HubSpot ID eingeben</ListItemText>
    </MenuItem>
  );
}
